import { Modal, ModalContent } from '@/components/modal/Modal'
import { ModalFooterWithActions } from '@/components/modal/ModalFooterWithActions'
import { ModalFooterWithActionsType } from '@/components/modal/constants'

export default function DeleteTableItemDialog({
  title,
  onCancel,
  onConfirm,
  saving,
  error,
  subtitle = 'This removes the selected item and its contents. This cannot be undone.',
  confirmLabel = 'Delete',
}: {
  title: string
  onCancel: () => void
  onConfirm: () => void
  saving: boolean
  error?: string | null
  subtitle?: string
  confirmLabel?: string
}) {
  return (
    <Modal
      open
      onOpenChange={(open) => {
        if (!open && !saving) onCancel()
      }}
    >
      <ModalContent
        title={title}
        subtitle={subtitle}
        width="md"
        height="max-md"
        footer={
          <ModalFooterWithActions
            type={ModalFooterWithActionsType.DESTRUCTIVE}
            secondaryAction={{ label: 'Cancel', onClick: onCancel, disabled: saving }}
            primaryAction={{ label: confirmLabel, onClick: onConfirm, loading: saving }}
          />
        }
      >
        {error && (
          <p role="alert" className="px-4 pb-4 text-sm text-red-800">
            {error}
          </p>
        )}
      </ModalContent>
    </Modal>
  )
}
